// Thin wrapper around Telegram WebApp HapticFeedback with throttle.
// iOS will silently drop selectionChanged() calls fired too close together;
// we keep them >= 35ms apart so every reel cell click reads physically.
//
// HapticFeedback is a Telegram-WebApp 6.1+ API. On older clients (and in the
// standalone browser preview) we silently no-op instead of letting Telegram
// flood the console with `"is not supported in version 6.0"` warnings
// (QA P1 #25).

import { tg, supportsTgFeature, TG_MIN_VERSION } from "./telegram";

let lastSelection = 0;

function hapticsAvailable(): boolean {
  return supportsTgFeature(TG_MIN_VERSION) && !!tg()?.HapticFeedback;
}

export function impact(style: "light" | "medium" | "heavy" | "rigid" | "soft"): void {
  if (!hapticsAvailable()) return;
  try {
    tg()?.HapticFeedback?.impactOccurred(style);
  } catch {
    /* ignore */
  }
}

export function notify(type: "success" | "warning" | "error"): void {
  if (!hapticsAvailable()) return;
  try {
    tg()?.HapticFeedback?.notificationOccurred(type);
  } catch {
    /* ignore */
  }
}

/** Per-cell click, call as often as you want, throttle keeps iOS happy. */
export function selection(now: number = performance.now()): void {
  if (now - lastSelection < 35) return;
  lastSelection = now;
  if (!hapticsAvailable()) return;
  try {
    tg()?.HapticFeedback?.selectionChanged();
  } catch {
    /* ignore */
  }
}
